import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchCertificationById } from '@/api/certifications';

export const certificationDetailKeys = {
  detail: (id: string) => ['certifications', 'detail', id] as const,
};

/** Shared by the route loader and the hook, so both land on one cache entry. */
export function certificationDetailQueryOptions(id: string) {
  return queryOptions({
    queryKey: certificationDetailKeys.detail(id),
    queryFn: () => fetchCertificationById(id).then(({ data }) => data),
    staleTime: 60_000,
  });
}

export function useCertificationDetail(id: string) {
  return useQuery(certificationDetailQueryOptions(id));
}
